Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var desktop = require('../../toast-plate/desktop');
var components_baseToast_component = require('../components/base-toast/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var DefaultToastPlateDesktop = React.forwardRef(function (props, ref) { return (React__default.default.createElement(desktop.ToastPlateDesktop, tslib.__assign({ ref: ref }, props))); });
var ToastDesktop = React.forwardRef(function (_a, ref) {
    var _b = _a.ToastPlate, ToastPlate = _b === void 0 ? DefaultToastPlateDesktop : _b, restProps = tslib.__rest(_a, ["ToastPlate"]);
    return (React__default.default.createElement(components_baseToast_component.BaseToast, tslib.__assign({ ToastPlate: ToastPlate }, restProps, { ref: ref })));
});

exports.ToastDesktop = ToastDesktop;
